type ValueOf<T> = T[keyof T];

export type SignalData = Record<string, unknown>;

export interface RpcCallPayload {
  callId: string;
  senderId: string;
  data?: SignalData;
}

export interface RpcCommandPayload {
  senderId: string;
  data?: SignalData;
}

export const PROTOCOL_RPC_METHODS = {
  clinician: {
    outgoing: {
      OFFER_TO_START: 'offerToStart',
      OFFER_TO_START_CANCELLED: 'offerToStartCancelled',
      START_RECORDING: 'startRecording',
      STOP_RECORDING: 'stopRecording',
      REPLAY_RECORDING: 'replayRecording',
      END_RECORDING_SESSION: 'endRecordingSession',
      TERMINATE: 'terminate'
    },
    incoming: {
      OFFER_ACCEPTED: 'offerAccepted',
      CALL_DECLINED: 'callDeclined',
      PROMPT_VIDEO_COMPLETE: 'promptVideoComplete',
      RECORDING_STARTED: 'recordingStarted',
      RECORDING_STOPPED: 'recordingStopped',
      REPLAY_COMPLETE: 'replayComplete',
      THANK_YOU_VIDEO_COMPLETE: 'thankYouVideoComplete',
      REQUEST_PROMPT_VIDEO: 'requestPromptVideo'
    }
  },
  patient: {
    outgoing: {
      OFFER_ACCEPTED: 'offerAccepted',
      CALL_DECLINED: 'callDeclined',
      PROMPT_VIDEO_COMPLETE: 'promptVideoComplete',
      RECORDING_STARTED: 'recordingStarted',
      RECORDING_STOPPED: 'recordingStopped',
      REPLAY_COMPLETE: 'replayComplete',
      THANK_YOU_VIDEO_COMPLETE: 'thankYouVideoComplete',
      REQUEST_PROMPT_VIDEO: 'requestPromptVideo'
    },
    incoming: {
      OFFER_TO_START: 'offerToStart',
      OFFER_TO_START_CANCELLED: 'offerToStartCancelled',
      START_RECORDING: 'startRecording',
      STOP_RECORDING: 'stopRecording',
      REPLAY_RECORDING: 'replayRecording',
      END_RECORDING_SESSION: 'endRecordingSession',
      TERMINATE: 'terminate'
    }
  }
} as const;

export type ProtocolClinicianOutgoingMethod = ValueOf<typeof PROTOCOL_RPC_METHODS.clinician.outgoing>;
export type ProtocolClinicianIncomingMethod = ValueOf<typeof PROTOCOL_RPC_METHODS.clinician.incoming>;
export type ProtocolPatientOutgoingMethod = ValueOf<typeof PROTOCOL_RPC_METHODS.patient.outgoing>;
export type ProtocolPatientIncomingMethod = ValueOf<typeof PROTOCOL_RPC_METHODS.patient.incoming>;
